<script setup>

</script>

<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.1667 14.6966V16C30.1649 19.0549 29.1757 22.0274 27.3466 24.4742C25.5174 26.921 22.9463 28.711 20.0168 29.5772C17.0872 30.4433 13.9561 30.3393 11.0905 29.2806C8.22489 28.2219 5.77827 26.2653 4.11554 23.7025C2.4528 21.1397 1.66305 18.1081 1.86405 15.0597C2.06506 12.0114 3.24605 9.10977 5.23091 6.78749C7.21576 4.46521 9.89812 2.84676 12.8779 2.17351C15.8578 1.50026 18.9754 1.80828 21.7659 3.05164M30.1667 4.66666L16 18.8475L11.75 14.5975"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped lang="scss">

</style>